import React from "react";
import _ from "lodash";
import {Grid, makeStyles} from "@material-ui/core";

import BaseDialog from "../../../../../../../../components/BaseDialog/BaseDialog";
import PrimaryButton from "../../../../../../../../components/Buttons/PrimaryButton";
import Portfolio from "../../../../../TradeStep/components/Portfolio";
import {getListWithToggledItem} from "../../utils";


const useStyles = makeStyles({
  dialogContent: {
    display: 'flex',
  },
});


/**
 * Simple modal for selecting instruments from the existing portfolio.
 * Used for Sell and Switch (portfolioOnly mode).
 */
const PortfolioSelectionModal = ({
  onClose,
  portfolioInstruments,
  instrumentsHandler,
  onSubmit,
  action,
  withSrri,
  clientSRRI,
  title='Produkte auswählen'
}) => {
  const classes = useStyles();
  const [selectedAssets, setSelectedAssets] = React.useState([]);

  const handleInstrumentSelect = React.useCallback((asset) => {
    setSelectedAssets(prev => getListWithToggledItem(prev, asset, (a) => a.isin));
  }, []);

  const handleSubmit = () => {
    onSubmit(selectedAssets);
    onClose();
  };

  return (
    <BaseDialog
      open
      maxWidth="lg"
      fullWidth
      disableBackdropClick
      title={title}
      handleClose={onClose}
      actions={(
        <Grid container spacing={2} justify="flex-end">
          <Grid item>
            <PrimaryButton variant={'outlined'} text="Abbrechen" onButtonClick={onClose} />
          </Grid>
          <Grid item>
            <PrimaryButton
              disabled={_.isEmpty(selectedAssets)}
              text="Speichern & fortfahren"
              onButtonClick={handleSubmit}
            />
          </Grid>
        </Grid>
      )}
      customClasses={{dialogContent: classes.dialogContent}}
      data-id="portfolio-selection-modal"
    >
      <Portfolio
        portfolioInstruments={portfolioInstruments}
        instrumentsHandler={instrumentsHandler}
        selectedAssets={selectedAssets}
        onInstrumentSelect={handleInstrumentSelect}
        onSelectAll={setSelectedAssets}
        action={action}
        withSrri={withSrri}
        clientSRRI={clientSRRI}
      />
    </BaseDialog>
  );
};

export default PortfolioSelectionModal;
